import React from 'react';
import 'twin.macro';
import { Icon } from '../icon';
import { NsfwIcon } from 'icons';

export const ItemActions = ({ item }) => (
  <div tw='flex-shrink-0 flex flex-col gap-1 justify-center'>
    {item.nsfw && <Icon Type={NsfwIcon} />}
  </div>
);
